import { detect } from 'detect-browser';

export function checkBrowser() {
  const browserInfo = detect() || { os: '', type: '', name: '', version: '' };

  const { os, type } = browserInfo;

  const isAndroidBrowser =
    (type === 'browser' && os && /Android OS/i.test(os)) ?? false;
  const isIosBrowser = (type === 'browser' && os && /iOS/i.test(os)) ?? false;
  const isMacSystem = (type === 'browser' && os && /Mac OS/i.test(os)) ?? false;

  // iPadOS 13+ reports a desktop macOS user agent, so it shows up here as
  // isMacSystem; a "Mac" with touch support is actually an iPad.
  const isIosDevice = Boolean(
    isIosBrowser || (isMacSystem && navigator.maxTouchPoints > 1),
  );

  return {
    isAndroidBrowser,
    isIosBrowser,
    isIosDevice,
    isMacSystem,
  };
}

export default function useBrowserCheck() {
  return checkBrowser();
}

export function useTypeBrowserCheck() {
  const browserInfo = detect() || { os: '', type: '', name: '', version: '' };
  const { os, type, name } = browserInfo;

  const isChrome = type === 'browser' && os && /chrome/i.test(name);
  const isFirefox = type === 'browser' && os && /firefox/i.test(name);
  const isSafari = type === 'browser' && os && /safari/i.test(name);
  const isEdge = type === 'browser' && os && /edge-chromium/i.test(name);

  return {
    isChrome,
    isFirefox,
    isSafari,
    isEdge,
  };
}
